export { default } from 'pages/support-v2/support-v2-form-page';
